export default "__VITE_ASSET__D1uDkWt2__"